import { combineReducers } from "redux";
import overrideRecuer from '../overrides/reducers'
import appReducer from '../reducers/appreducer'
import securityReducer from "../reducers/securityreducer";

const rootReducer = combineReducers(
    Object.assign({
        appReducer: appReducer,
        securityReducer: securityReducer,
       },
    overrideRecuer()  
    )
);

export default rootReducer;